var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['cpt-chat-img', {'img-info-block': _vm.img_info && _vm.img_info.width}]},[(_vm.img_info && _vm.img_info.width)?_c('img',{staticClass:"preload-img",attrs:{"src":`data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="${_vm.img_info.width}" height="${_vm.img_info.height}" viewBox="0 0 894 536"><rect opacity="0" width="894" height="536"/></svg>`,"alt":""}}):_vm._e(),_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidden_gif),expression:"!hidden_gif"}],ref:"img-dom",class:[
      'img-dom', 
      `img-fit-${_vm.fit}`, 
      {
        'preview': _vm.canPreview, 
        'lazy': _vm.lazy, 
        'animation': _vm.animation,
        'opacity': _vm.animation
      }
    ],attrs:{"alt":"image","src":(!_vm.lazy && !_vm.animation) ? _vm.real_src : _vm.PRELOAD_IMG},on:{"click":_vm.openImage,"error":function($event){return _vm.$emit('error')},"load":_vm.handleLoad}})])
}
var staticRenderFns = []

export { render, staticRenderFns }